import MyContainer from '@/components/MyContainer';
import StockMovementAsyncTable from './components/stock-movement-async-data-table';
import { LinkButton } from "@/components/ui/buttons/link-button";
import { BulkStockUploadDialog } from "@/components/stock/BulkStockUploadDialog";
import { useState } from "react";

export default function StockMovementPage() {
  const [isUploadDialogOpen, setIsUploadDialogOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleUploadStock = () => {
    setIsUploadDialogOpen(true);
  };

  const handleUploadSuccess = () => {
    // Trigger table refresh by updating key
    setRefreshKey(prev => prev + 1);
  };

  return (
    <>
      <MyContainer
        enableBack={false}
        title="Stock Movement Timeline"
        subtitle="Track inventory movements across all products and variants"
        actions={<LinkButton label="Upload Stock" onClick={handleUploadStock} />}
      >
        <StockMovementAsyncTable key={refreshKey} />
      </MyContainer>

      <BulkStockUploadDialog
        open={isUploadDialogOpen}
        onOpenChange={setIsUploadDialogOpen}
        onSuccess={handleUploadSuccess}
      />
    </>
  );
}
